/**
 * Convert a frequency trip object into readable time strings
 * @param {Object} frequency - Object with start_time, end_time, headway_secs
 * @returns {string[]} - Array of times like ["06:00 am", "06:20 am", ...]
 */
export function expandFrequencyTimes(frequency) {
    const { start_time, end_time, headway_secs } = frequency;

    const result = [];

    // Parse time strings into seconds
    const start = timeToSeconds(start_time);
    const end = timeToSeconds(end_time);
    const interval = parseInt(headway_secs, 10);

    for (let t = start; t <= end; t += interval) {
        result.push(secondsToAmPm(t));
    }

    return result;
}

/**
 * Convert "HH:MM:SS" to seconds
 */
function timeToSeconds(timeStr) {

    const [hh, mm, ss] = timeStr.split(':').map(Number);
    return hh * 3600 + mm * 60 + ss;
}

/**
 * Convert seconds to "hh:mm am/pm"
 */
function secondsToAmPm(seconds) {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds % 3600) / 60);

    const ampm = h >= 12 ? 'pm' : 'am';
    h = h % 12;
    if (h === 0) h = 12;

    const paddedMinutes = m.toString().padStart(2, '0');
    return `${h}:${paddedMinutes} ${ampm}`;
}
